import logo from '~/assets/images/logo.png';

const images = {
  logo,
};

export default images;
